// @ts-nocheck
// Stats dashboard. Calls the admin_stats RPC and renders cards.
// Layout intentionally roomy so future stats slot in without redesign.

import { useEffect, useState } from "react";
import { supabase } from "../../lib/supabase";

type Stats = {
  users_total: number;
  users_last_7d: number;
  invitations_total: number;
  invitations_claimed: number;
  reviews_total: number;
  reviews_last_7d: number;
  purchases_total: number;
  purchases_last_7d: number;
};

export function AdminOverview() {
  const [stats, setStats] = useState<Stats | null>(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data, error } = await supabase.rpc("admin_stats");
      if (cancelled) return;
      if (error) setError(error.message);
      else setStats(data);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (error) return <div className="adm-error">{error}</div>;
  if (!stats) return <div className="adm-loading">טוען נתונים…</div>;

  const claimRate = stats.invitations_total
    ? Math.round((stats.invitations_claimed / stats.invitations_total) * 100)
    : 0;

  return (
    <>
      <div className="adm-grid">
        <Stat
          label="משתמשים רשומים"
          value={stats.users_total}
          sub={`+${stats.users_last_7d} בשבוע האחרון`}
        />
        <Stat
          label="הזמנות לסקירה"
          value={stats.invitations_total}
          sub={`${stats.invitations_claimed} ניצלו (${claimRate}%)`}
        />
        <Stat
          label="משובים שהוגשו"
          value={stats.reviews_total}
          sub={`+${stats.reviews_last_7d} בשבוע האחרון`}
        />
        <Stat
          label="רכישות"
          value={stats.purchases_total}
          sub={`+${stats.purchases_last_7d} בשבוע האחרון`}
        />
      </div>

      <div className="adm-card" style={{ marginTop: 20 }}>
        <h3>מה לבנות הלאה</h3>
        <ul style={{ paddingRight: 22, lineHeight: 2, color: "#5C3D2E" }}>
          <li>סליקה דרך Lemon Squeezy + מסך רכישות בפאנל</li>
          <li>גרף קונברסיה (כניסה לדף ← רכישה)</li>
          <li>גרף השלמת פרקים (איפה נושרים)</li>
          <li>חוגי קריאה — רשימה, חברים פעילים, פעילות אחרונה</li>
          <li>בקרה ואכיפה — מכשירים פעילים, חריגות מ‑rate limiting</li>
        </ul>
      </div>
    </>
  );
}

function Stat({
  label,
  value,
  sub,
}: {
  label: string;
  value: number;
  sub?: string;
}) {
  return (
    <div className="adm-stat">
      <div className="adm-stat-label">{label}</div>
      <div className="adm-stat-value">{value}</div>
      {sub && <div className="adm-stat-sub">{sub}</div>}
    </div>
  );
}
